import { useState } from 'react';
import OrderList from './OrderList'
import OrderItemPlaceHolder from './OrderItemPlaceHolder'
const PointerMenu = ({ menuItems, loading }) => {
    const [activeTab, setActiveTab] = useState('All')
    const renderMenuItems = [];
    const renderMenuSegments = [];
    const renderPlaceHolder = () => {
        const ph = []
        for (let i = 0; i < 5; i++){
            ph.push(
                <OrderItemPlaceHolder key={i}/>
            )
        }
        return ph
    }
    menuItems.forEach((x, i) => {
        renderMenuItems.push((
            <span className={`item ${x.name === activeTab && "active"}`} style={{cursor: 'pointer'}} key={i} onClick={() => setActiveTab(x.name)}>
                {x.name}
            </span>
        ))
        if (x.data.length > 0 && x.name === activeTab){
            renderMenuSegments.push((
                <OrderList orders={x.data} key={i}/>
        ))
            }
        else if (x.data.length === 0 && x.name === activeTab){
            renderMenuSegments.push((
                <p key={i}>There is no {x.name === 'Done' ? "Completed" : x.name} Orders.</p>
            ))
        }
        

    })
    return (
        <>
            <div className="ui pointing menu">
                {renderMenuItems}
            </div>
            <div className="ui segment">
                {loading ? renderPlaceHolder() : renderMenuSegments}
            </div>
        </>
    )
}

export default PointerMenu
